module.exports = __webpack_public_path__ + "static/media/k1-texture-transparent.6860a06b.png";